export const mapFlexDayDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    startDate: dto.start_date,
    endDate: dto.end_date,
    numberDays: dto.number_days,
    approvalStatus: dto.approval_status ?? 'pending',
    displayName: dto.user_name ?? null,
    rejectionReason: dto.rejection_reason ?? null,
});
